import Styles from './BlazeIcon.module.scss'

interface Props {
  icon: JSX.Element
  color: string
}

export const BlazeIcon = ({ icon, color }: Props) => (
  <div className={Styles.icon} style={{ backgroundColor: color }}>
    {icon}
  </div>
)
